export const LoadingTypes = {
    LOADING_START : 'LOADING_START_LOADING',
    LOADING_END : 'LOADING_END_LOADING',
    HANDLE_ERROR : 'LOADING_HANDLE_ERROR',
    SHOW_ERROR : 'LOADING_SHOW_ERROR',
    SET_CONNECTION_STATUS : 'LOADING_SET_CONNECTION_STATUS',
    SET_BUGREPORT_STATUS : 'LOADING_SET_BUGREPORT_STATUS',
};